import React, { useState, useEffect } from "react";
import { isValNull } from "../../../utils";
import { getDashboardUrl } from "../../../views/Home";
import Table from "../../Common/Table";

const handlePickupUserIdClick = (pickup_user_id) => {
  if (!isValNull(pickup_user_id)) {
     const url = `${getDashboardUrl()}/admin/users/${pickup_user_id}`;
     window.open(url);
  }
};

const getFieldValue = (item, key) => {
  if (key === 'value' && item.key === 'pickup_user_id') {
    return (
      <span
        onClick={() => handlePickupUserIdClick(item.value)}
        className="edit-options"
      >
        {item.value}
      </span>
    );
  }
  return item[key];
};

const OrdersBasicTable = ({ data = {} }) => {
  function getItems() {
    let items = [];
    for (let key in data) {
      if (data.hasOwnProperty(key)) {
        items.push({
          key: key,
          value: JSON.stringify(data[key]),
        });
      }
    }
    return items;
  }

  return (
    <Table
      blankStateComponent={null}
      fields={["key", "value"].map((v) => {
        return {
          heading: v,
          key: v,
        };
      })}
      list={getItems()}
      getFieldValue={getFieldValue}
    />
  );
};

export default OrdersBasicTable;
